import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from "../../components/boutons/button/button.component";
import { LucideAngularModule } from 'lucide-angular';
import { forkJoin, Observable } from 'rxjs';
import { AsyncPipe, NgClass } from '@angular/common';
import { ResponsiveService } from '../../services/reponsive.service';
import { TranslateModule } from '@ngx-translate/core';
import { DownloadService } from '../../services/download.service';
import { HttpEvent } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { JobService } from '../../services/job.service';

@Component({
  selector: 'app-video-editing',
  imports: [TranslateModule, ReactiveFormsModule, NgClass, AsyncPipe, ButtonComponent, LucideAngularModule],
  templateUrl: './video-editing.component.html',
  styleUrl: './video-editing.component.scss'
})
export class VideoEditingComponent {

  @ViewChild('audioVocal', { static: false }) vocalRef!: ElementRef<HTMLAudioElement>;
  @ViewChild('audioMusic', { static: false }) musicRef!: ElementRef<HTMLAudioElement>;
  @ViewChild('audioTranslated', { static: false }) translatedRef!: ElementRef<HTMLAudioElement>;
  @ViewChild('videoPlayer', { static: false }) videodRef!: ElementRef<HTMLVideoElement>;

  //? Injection des services
  private responsiveService: ResponsiveService = inject(ResponsiveService);
  private jobService:JobService = inject(JobService);
  private downloadService: DownloadService = inject(DownloadService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);

  // Responsives
  smallScreen$: Observable<boolean> = this.responsiveService.small$;
  mediumScreen$: Observable<boolean> = this.responsiveService.desktop$;
  largeScreen$: Observable<boolean> = this.responsiveService.largeDesktop$;

  assetsLoaded: boolean = false;

  jobId: string | undefined | null = null;
  taskId: string | undefined | null = null;

  vocalsUrl: string = '';
  translatedAudioUrl: string = '';
  musicUrl: string = '';
  videoCleanUrl: string = '';

  isPlaying: boolean = false;
  defaultAudio: number = 0.5;

  audioForm: FormGroup = new FormGroup({
    originalVolume: new FormControl(this.defaultAudio),
    translationVolume: new FormControl(this.defaultAudio),
    musicVolume: new FormControl(this.defaultAudio),
  })

  // pour lancer la vidéo & tout les fichiers son
  play(): void {
    const vocalPlayer: HTMLAudioElement = this.vocalRef.nativeElement;
    const musicPlayer: HTMLAudioElement = this.musicRef.nativeElement;
    const translatedPlayer: HTMLAudioElement = this.translatedRef.nativeElement;
    const videoPlayer: HTMLVideoElement = this.videodRef.nativeElement;
    if (this.isPlaying) {
      vocalPlayer.pause();
      musicPlayer.pause();
      translatedPlayer.pause();
      videoPlayer.pause()
      this.isPlaying = false;
      return
    }
    vocalPlayer.play();
    musicPlayer.play();
    translatedPlayer.play();
    videoPlayer.play()
    this.isPlaying = true;
  }

  stop(): void {
    const vocalPlayer: HTMLAudioElement = this.vocalRef.nativeElement;
    const musicPlayer: HTMLAudioElement = this.musicRef.nativeElement;
    const translatedPlayer: HTMLAudioElement = this.translatedRef.nativeElement;
    const videoPlayer: HTMLVideoElement = this.videodRef.nativeElement;
    vocalPlayer.pause();
    musicPlayer.pause();
    translatedPlayer.pause();
    videoPlayer.pause()
    vocalPlayer.currentTime = 0;
    musicPlayer.currentTime = 0;
    translatedPlayer.currentTime = 0;
    videoPlayer.currentTime = 0
    this.isPlaying = false;
  }

  complete(): void {
    if(!this.jobId || !this.taskId) throw new Error('Job ID or Task ID is not defined');
    this.jobService.postSoundsParameters(parseInt(this.jobId), parseInt(this.taskId), this.audioForm.value.originalVolume, this.audioForm.value.translationVolume, this.audioForm.value.musicVolume).subscribe(() => {
      console.log('sounds parameters updated successfully');
      this.router.navigate(['/dashboard/job', this.jobId]);
    })
  }


  loadAudio(jobId: number): void {
    const assets: string[] = ['vocals', 'translatedAudio', 'music']
    const assetsOberservables: Observable<HttpEvent<Blob>>[] = []
    assets.forEach((vocal: string) => assetsOberservables.push(
      this.downloadService.downloadAsset(jobId, `${vocal}.wav`)
    ));
    assetsOberservables.push(this.downloadService.downloadAsset(jobId, 'videoClean.mp4'))
    forkJoin(assetsOberservables).subscribe(([vocals, translatedAudio, music, videoClean]) => {
      this.vocalsUrl = this.convertBlobToUrl(vocals) ?? ''
      this.translatedAudioUrl = this.convertBlobToUrl(translatedAudio) ?? ''
      this.musicUrl = this.convertBlobToUrl(music) ?? ''
      this.videoCleanUrl = this.convertBlobToUrl(videoClean) ?? ''
      this.assetsLoaded = true;
    })
  }

  convertBlobToUrl(assetEvent: HttpEvent<Blob>): string | undefined {
    if (assetEvent.type === 4 && 'body' in assetEvent && assetEvent.body) {
      return URL.createObjectURL(assetEvent.body)
    }
    return undefined;
  }


  ngOnInit(): void {
    this.jobId = this.route.parent?.snapshot.paramMap.get('id');
    this.taskId = this.route.snapshot.paramMap.get('taskId');
    if (this.jobId) this.loadAudio(parseInt(this.jobId));
  }
}
